webpackJsonp([59956827976669],{

/***/ 271:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mainContentContainer":"src-pages-klub----skupine-module---mainContentContainer---36tXV","mainContent":"src-pages-klub----skupine-module---mainContent---1Tqk_","imageContainer":"src-pages-klub----skupine-module---imageContainer---2UhAC"};

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMarkdown = __webpack_require__(62);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _AsyncImage = __webpack_require__(28);
	
	var _AsyncImage2 = _interopRequireDefault(_AsyncImage);
	
	var _skupineModule = __webpack_require__(271);
	
	var _skupineModule2 = _interopRequireDefault(_skupineModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var _data$contentfulPodst = data.contentfulPodstran,
	      _data$contentfulPodst2 = _data$contentfulPodst.image,
	      url = _data$contentfulPodst2.file.url,
	      description = _data$contentfulPodst2.description,
	      vsebina = _data$contentfulPodst.vsebina.vsebina;
	
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: _skupineModule2.default.contentContainer },
	      _react2.default.createElement(
	        "div",
	        { className: _skupineModule2.default.mainContentContainer },
	        _react2.default.createElement(
	          "div",
	          { className: _skupineModule2.default.imageContainer },
	          _react2.default.createElement(_AsyncImage2.default, {
	            imageUrl: url,
	            placeholderColor: "#ecf0f1",
	            alt: description
	          })
	        ),
	        _react2.default.createElement(_reactMarkdown2.default, { className: _skupineModule2.default.mainContent, source: vsebina })
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-klub-urniki-js-9ab1e0444f782e76fd9f.js